import { useCallback } from 'react';
import type { ScrollView } from 'react-native';

export function useScroll(scrollRef) {
  const scrollView = scrollRef?.current as ScrollView;

  const scrollToEnd = useCallback(() => {
    setTimeout(() => {
      scrollView?.scrollToEnd?.();
      window?.scrollTo?.({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    }, 50);
  }, [scrollView]);

  const scrollToTop = useCallback(() => {
    setTimeout(() => {
      scrollView?.scrollTo?.({
        x: 0,
        y: 0,
        animated: true,
      });
      window?.scrollTo?.({ top: 0, behavior: 'smooth' });
    }, 50);
  }, [scrollView]);

  return {
    scrollToTop,
    scrollToEnd,
  };
}
